module.exports = __webpack_public_path__ + "assets/img/zh-Hant-d7af2f56.png";